// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.card-header[data-v-420d07c7] { background: #fafafa;\n}\n.input-group-text[data-v-420d07c7] {\n  height: 36px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n.list-group-item .input-group-text[data-v-420d07c7] {\n  border: none;\n  background: transparent;\n  padding: 0;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
